// extracted by mini-css-extract-plugin
export default {"card":"styles_card__W30Y+","selected":"styles_selected__NINYv","image":"styles_image__eq7r2","content":"styles_content__WiHh8","container":"styles_container__BEj8v"};